export default "__VITE_ASSET__$pAIIKNu__"